module.exports = __webpack_public_path__ + "static/img/lm-loop-close.bc7ecf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lm-loop-close.png
// module id = VuBT
// module chunks = 0